import './assets/css/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import i18n from '../i18next.config'
import App from './App.vue'
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSplide from '@splidejs/vue-splide'

import { createHead } from '@unhead/vue/client'

library.add(fas, far);

const head = createHead();
const app = createApp(App)

app.use(i18n)
app.use(createPinia())
app.use(VueSplide)
app.use(router)
app.use(head)
app.component('font-awesome-icon', FontAwesomeIcon)
app.mount('#app')